<style>

.card{
  position: relative;
  color: white;
}

.starts-in {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.6);
}
.stars{
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.6);
}
.info{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 5px;
  /* border: 1px red solid; */
  /* margin-top: -40px; */
  background-color: rgba(0,0,0,0.6);
}
.name{
  font-size: 21px;
}

</style>

<div bind:clientWidth="{height}"></div>

<div class="card" on:click="{ () => dispatch('click') }">
  <Image src="/ei/cookie/csrf/{item.eid}/{item.photoIds[0]}" alt="event" style="object-fit: cover; width: 100%;"></Image>
  <div class="starts-in"><StartsIn currentTime="{currentTime}" start="{item.start}" end="{item.end}"></StartsIn></div>
  
  <div class="stars"><Stars stars="{item.stars}"></Stars></div>
  
  <div class="info">
    {#if showName}
    <div class="name">{item.ename}</div>
    {/if}
    <div><EventTime start="{item.start}" end="{item.end}"></EventTime></div>
  </div>
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Stars from "./Stars.svelte";
import EventTime from "./EventTime.svelte";
import StartsIn from "./StartsIn.svelte";
import Image from "./Image.svelte";

export let item = {};
export let currentTime = 0;
export let showName = true;

let height = 100;


</script>